import { api } from './api';

export interface ContactFormData {
  name: string;
  email: string;
  country: string;
  message: string;
}

export interface ContactResponse {
  contactId: string;
  emailStatus: 'PENDING' | 'SENT' | 'FAILED';
  adminNotified: boolean;
}

export interface ApiResponse<T> {
  success: boolean;
  message: string;
  data: T;
}

export const contactService = {
  async sendMessage(data: ContactFormData): Promise<ContactResponse> {
    const response = await api.post<ApiResponse<ContactResponse>>('/contact', data);
    return response.data.data;
  },
};

